// Initialize compare list and reference category from local storage
let compareList = JSON.parse(localStorage.getItem('compareList')) || [];
let referenceCategory = JSON.parse(localStorage.getItem('compareReferenceCategory')) || null;

// Log initial state for debugging
console.log('Initial compareList:', compareList);
console.log('Initial referenceCategory:', referenceCategory);

// Helper function to decode HTML entities
function decodeHtml(html) {
  try {
    if (typeof html !== 'string') {
      console.warn('decodeHtml: Input is not a string:', html);
      return '';
    }
    const txt = document.createElement('textarea');
    txt.innerHTML = html;
    const decoded = txt.value;
    return decoded;
  } catch (error) {
    console.error('Error in decodeHtml:', error);
    return '';
  }
}

// Helper function to parse HTML table and extract key-value pairs
function parseSpecsTable(html) {
  try {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const rows = doc.querySelectorAll('tr.spec-wrap');
    const specs = Array.from(rows).map(row => {
      const label = row.querySelector('.spec-label')?.textContent.trim() || '';
      const value = row.querySelector('.spec-value')?.textContent.trim() || '';
      return { label, value };
    }).filter(spec => spec.label && spec.value);
    console.log('Parsed specs:', specs);
    return specs;
  } catch (error) {
    console.error('Error parsing specs table:', error);
    return [];
  }
}

// Helper function to show modal popup - FIXED: Higher z-index, backdrop, body scroll lock, longer auto-close
function showModal(message, isError = false) {
  try {
    console.log('showModal called:', { message, isError });
    // Remove existing modal if any
    const existingModal = document.querySelector('.compare-modal');
    if (existingModal) {
      console.log('Removing existing modal');
      existingModal.remove();
    }

    // Calculate the number of products added and remaining slots
    const productsAdded = compareList.length;
    const maxProducts = 5;
    const remainingSlots = maxProducts - productsAdded;

    // Append the product count information to the message (only for non-error messages)
    const enhancedMessage = isError
      ? message
      : `${message} (${productsAdded} of ${maxProducts} products added. You can add ${remainingSlots} more.)`;

    // Create modal elements with backdrop
    const modal = document.createElement('div');
    modal.className = `compare-modal ${isError ? 'error' : ''}`;
    modal.innerHTML = `
      <div class="compare-modal__backdrop"></div> <!-- NEW: Backdrop for better visibility -->
      <div class="compare-modal__content">
        <div class="icon-wrap">
          <svg width="20" height="21" viewBox="0 0 20 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.6313 11.8125H19.6875V13.125H19.4619C19.3252 13.5146 19.1338 13.8701 18.8877 14.1914C18.6416 14.5127 18.3511 14.7896 18.0161 15.022C17.6812 15.2544 17.3257 15.4321 16.9497 15.5552C16.5737 15.6782 16.1738 15.7432 15.75 15.75C15.3398 15.75 14.9399 15.6885 14.5503 15.5654C14.1606 15.4424 13.8018 15.2646 13.4736 15.0322C13.1455 14.7998 12.8584 14.5229 12.6123 14.2017C12.3662 13.8804 12.1748 13.5215 12.0381 13.125H11.8125V11.8125H12.8687L14.7861 6.07031L10.5 4.64502V17.083C11.6553 17.1582 12.7388 17.4146 13.7505 17.8521C14.7622 18.2896 15.6919 18.9014 16.5396 19.6875H18.375V21H1.3125V19.6875H3.14795C3.98877 18.9082 4.91846 18.2998 5.93701 17.8623C6.95557 17.4248 8.03906 17.165 9.1875 17.083V4.2041L5.14746 2.86084L6.81885 7.875H7.875V9.1875H7.64941C7.5127 9.57715 7.32129 9.93262 7.0752 10.2539C6.8291 10.5752 6.53857 10.8521 6.20361 11.0845C5.86865 11.3169 5.51318 11.4946 5.13721 11.6177C4.76123 11.7407 4.36133 11.8057 3.9375 11.8125C3.52734 11.8125 3.12744 11.751 2.73779 11.6279C2.34814 11.5049 1.98926 11.3271 1.66113 11.0947C1.33301 10.8623 1.0459 10.5854 0.799805 10.2642C0.553711 9.94287 0.362305 9.58398 0.225586 9.1875H0V7.875H1.05615L2.97363 2.13281L0.287109 1.24072L0.70752 0L9.1875 2.81982V0H10.5V3.26074L19.3901 6.21387L18.9697 7.46484L16.9497 6.78809L18.6313 11.8125ZM6.21387 9.1875H1.66113C1.90039 9.59766 2.22168 9.91895 2.625 10.1514C3.02832 10.3838 3.46582 10.5 3.9375 10.5C4.40918 10.5 4.84668 10.3838 5.25 10.1514C5.65332 9.91895 5.97461 9.59766 6.21387 9.1875ZM5.43457 7.875L3.9375 3.38379L2.44043 7.875H5.43457ZM9.84375 18.375C9.03711 18.375 8.24756 18.4844 7.4751 18.7031C6.70264 18.9219 5.97461 19.25 5.29102 19.6875H14.3965C13.7197 19.2568 12.9917 18.9321 12.2124 18.7134C11.4331 18.4946 10.6436 18.3818 9.84375 18.375ZM15.75 7.32129L14.2529 11.8125H17.2471L15.75 7.32129ZM18.0264 13.125H13.4736C13.7129 13.5352 14.0342 13.8564 14.4375 14.0889C14.8408 14.3213 15.2783 14.4375 15.75 14.4375C16.2217 14.4375 16.6592 14.3213 17.0625 14.0889C17.4658 13.8564 17.7871 13.5352 18.0264 13.125Z" fill="black"></path>
          </svg>
        </div>
        <h4 class="compare-title">Compare Product</h4>
        <p class="compare-modal__message">${enhancedMessage}</p>
        <div class="button-row">
          <a href="/pages/compare-products" class="btn">View Page</a>
          <button class="compare-modal__close btn">Close</button>
        </div>
      </div>
    `;
    document.body.appendChild(modal);

    // FIXED: Enhanced styles - higher z-index, fixed positioning, backdrop
    modal.style.display = 'flex';
    modal.style.zIndex = '999999'; // MUCH higher to beat theme overlays
    modal.style.position = 'fixed';
    modal.style.top = '0';
    modal.style.left = '0';
    modal.style.width = '100%';
    modal.style.height = '100%';
    modal.style.alignItems = 'center';
    modal.style.justifyContent = 'center';
    modal.style.backgroundColor = 'rgba(0,0,0,0.5)'; // NEW: Semi-transparent backdrop on whole modal

    // NEW: Lock body scroll to prevent interference
    document.body.style.overflow = 'hidden';
    console.log('Modal appended to DOM, styles applied');

    // Verify modal is in DOM
    if (!document.body.contains(modal)) {
      console.error('Modal not found in DOM after append');
      console.warn('Modal failed - check console for conflicts'); // FIXED: Warn instead of alert
      return;
    }

    // Check computed styles
    const computedStyle = window.getComputedStyle(modal);
    if (computedStyle.display === 'none' || computedStyle.visibility === 'hidden') {
      console.error('Modal is not visible:', { display: computedStyle.display, visibility: computedStyle.visibility });
      console.warn('Modal visibility failed - possible CSS conflict'); // FIXED: Warn instead of alert
      return;
    }

    // Close modal on button click
    const closeButton = modal.querySelector('.compare-modal__close');
    closeButton.addEventListener('click', () => {
      console.log('Modal close button clicked');
      closeModal(modal); // NEW: Centralized close
    });

    // Close modal on outside click (backdrop only)
    modal.addEventListener('click', (event) => {
      if (event.target.classList.contains('compare-modal__backdrop')) { // FIXED: Only backdrop, not content
        console.log('Modal closed via backdrop click');
        closeModal(modal);
      }
    });

    // FIXED: Longer auto-close (5s) for better UX/testing
    setTimeout(() => {
      console.log('Modal auto-close triggered');
      closeModal(modal);
    }, 5000);
  } catch (error) {
    console.error('Error in showModal:', error);
    console.warn('showModal failed - using console warn'); // FIXED: No alert fallback
  }
}

// NEW: Centralized modal close function
function closeModal(modal) {
  if (document.body.contains(modal)) {
    modal.remove();
  }
  // Restore body scroll
  document.body.style.overflow = '';
}

// Debounce utility to limit function calls - FIXED: Shorter delay for faster filter response
function debounce(func, wait) {
  let timeout;
  return function (...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(this, args), wait);
  };
}

// Function to update comparison count
function updateCompareCount() {
  try {
    const countElements = document.querySelectorAll('.compare-count');
    countElements.forEach(element => {
      element.textContent = compareList.length;
    });
    console.log('Updated compare count:', compareList.length);
  } catch (error) {
    console.error('Error in updateCompareCount:', error);
  }
}

// Helper function to fetch product metafields using Shopify Storefront API (GraphQL)
async function fetchProductMetafields(productHandle) {
  try {
    console.log('Fetching metafields for handle:', productHandle);
    if (!productHandle) {
      throw new Error('Product handle is missing');
    }
    // Check if window.Shopify exists and has shopDomain
    if (!window.Shopify || !window.Shopify.shop) {
      throw new Error('Shopify global object not available');
    }

    // Check cache first
    const categoryCache = JSON.parse(localStorage.getItem('categoryCache')) || {};
    if (categoryCache[productHandle]) {
      console.log(`Cache hit for ${productHandle}:`, categoryCache[productHandle]);
      return categoryCache[productHandle];
    }

    const response = await fetch(`https://${window.Shopify.shop}/api/2024-10/graphql.json`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': 'YOUR_STOREFRONT_ACCESS_TOKEN', // Replace with your Storefront API token
      },
      body: JSON.stringify({
        query: `
          query getProduct($handle: String!) {
            product(handle: $handle) {
              id
              handle
              metafield(namespace: "gentech", key: "primary_category") {
                value
              }
            }
          }
        `,
        variables: { handle: productHandle },
      }),
    });

    if (!response.ok) {
      throw new Error(`GraphQL request failed: ${response.statusText}`);
    }

    const { data } = await response.json();
    const primaryCategory = data?.product?.metafield?.value || null;
    console.log(`Fetched metafields for ${productHandle}:`, { primaryCategory });

    // Cache the result
    if (primaryCategory) {
      categoryCache[productHandle] = primaryCategory;
      localStorage.setItem('categoryCache', JSON.stringify(categoryCache));
    }

    return primaryCategory;
  } catch (error) {
    console.error(`Error fetching metafields for ${productHandle}:`, error);
    return null;
  }
}

// Function to get or fetch category for a product
async function getProductCategory(product) {
  try {
    console.log('Getting category for product:', product?.handle || 'unknown', 'Product data:', product);
    let category = null;

    // Try local metafield first
    if (product?.metafields?.gentech?.primary_category) {
      category = product.metafields.gentech.primary_category;
      console.log('Found local category:', category);
    }

    // If category is missing or invalid, try fetching
    if (!category || typeof category !== 'string' || category.trim() === '') {
      if (product?.handle) {
        category = await fetchProductMetafields(product.handle);
      } else {
        console.warn('Cannot fetch category: product handle is missing', product);
      }
    }

    // Ensure it's a valid string
    if (category && typeof category === 'string' && category.trim() !== '') {
      // console.log('Returning category:', category.trim());
      return category.trim();
    }

    console.warn('No valid category found for product:', product);
    return null;
  } catch (error) {
    console.error('Error in getProductCategory:', error);
    return null;
  }
}

// Function to update "Add to Compare" button states based on reference category - FIXED: Better error handling, don't disable on parse error
async function updateCompareButtonStates() {
  try {
    // console.log('Updating button states with referenceCategory:', referenceCategory);

    // Get all buttons
    const buttons = document.querySelectorAll('.add-to-compare');
 
    // If no reference category or empty compareList, enable all buttons
    if (!referenceCategory || compareList.length === 0) {
      buttons.forEach(button => {
        button.classList.remove('disabled');
        button.disabled = false;
        // console.log(`Enabled button:`, button.dataset.product ? 'has data' : 'no data-product');
      });
      // console.log('No reference category, enabled all buttons');
      return;
    }

    // Iterate through buttons
    for (const button of buttons) {
      try {
        const productData = button.dataset.product;
        // console.log('Processing button with data-product length:', productData ? productData.length : 0);
        if (!productData) {
          console.warn('Button missing data-product:', button);
          // FIXED: Don't disable if no data - just skip
          continue;
        }
        let product;
        try {
          // FIXED: Enhanced cleaning for duplicate keys/malformed JSON - REMOVED unnecessary unescape for \" to prevent corruption
          let cleanedProductData = productData
            .replace(/,\s*}/g, '}') // Remove trailing commas before }
            .replace(/,\s*]/g, ']') // Remove trailing commas before ]
            .replace(/\\\//g, '/')  // Unescape forward slashes (kept for path escapes)
            .replace(/\\n/g, '')    // Remove escaped newlines
            .replace(/null/g, '""') // Convert null to empty string
            .replace(/("specs":\s*\{[^}]*\}),\s*("specs":\s*\{[^}]*\})/g, '$1') // FIXED: Remove duplicate "specs" keys
            .trim();

          product = JSON.parse(cleanedProductData);
          // console.log('Parsed product for button:', product.id || 'no id');
        } catch (parseError) {
          console.error('JSON parse error for button:', parseError, 'Data snippet:', productData.substring(0, 100));
          // FIXED: On parse error, enable button (don't disable) and skip category check
          button.classList.remove('disabled');
          button.disabled = false;
          continue;
        }

        if (!product.handle || !product.id) {
          console.warn('Product missing handle or id:', product);
          // FIXED: Enable on missing fields instead of disable
          button.classList.remove('disabled');
          button.disabled = false;
          continue;
        }

        const productCategory = await getProductCategory(product);
        // console.log(`Button for product ${product.handle}: category ${productCategory}`);

        if (productCategory && referenceCategory.toLowerCase() === productCategory.toLowerCase()) {
          button.classList.remove('disabled');
          button.disabled = false;
          // console.log(`Enabled button for ${product.handle}`);
        } else {
          // FIXED: Only disable if categories mismatch AND both are non-null
          if (productCategory && referenceCategory) {
            button.classList.add('disabled');
            button.disabled = true;
            // console.log(`Disabled button for ${product.handle} (mismatch: ${productCategory} vs ${referenceCategory})`);
          } else {
            // If either category is null, enable (fallback)
            button.classList.remove('disabled');
            button.disabled = false;
            // console.log(`Enabled button for ${product.handle} (null category fallback)`);
          }
        }
      } catch (error) {
        console.error(`Error processing button:`, button.dataset.product ? 'has data' : 'no data', error);
        // FIXED: On any error, enable button to prevent hiding
        button.classList.remove('disabled');
        button.disabled = false;
        // console.log(`Enabled button due to error fallback`);
      }
    }
  } catch (error) {
    // console.error('Error in updateCompareButtonStates:', error);
  }
}

// Function to add product to comparison
async function addToCompare(product) {
  try {
    // console.log('addToCompare called with product:', product);
    // console.log('Current compareList:', compareList);
    if (!product.id || typeof product.id !== 'number') {
      console.error('Invalid product ID:', product.id);
      showModal('Error: Invalid product ID.', true);
      return;
    }

    // Check for duplicate product
    if (compareList.some(item => String(item.id) === String(product.id))) {
      // console.log('Duplicate product ID:', product.id);
      showModal('This product is already in your comparison list.', true);
      return;
    }

    // Check maximum product limit
    if (compareList.length >= 5) {
      // console.log('Maximum product limit reached:', compareList.length);
      showModal('You can compare up to 5 products. Remove one to add more.', true);
      return;
    }

    // Get category for the new product (optional, with fallback)
    let newCategory = null;
    try {
      newCategory = await getProductCategory(product);
      // console.log('Final new product category:', newCategory);
    } catch (error) {
      console.warn('Category fetch failed, proceeding without category:', error);
    }

    // Check category compatibility (relaxed to allow null categories)
    if (compareList.length > 0) {
      const existingProduct = compareList[0];
      let existingCategory = null;
      try {
        existingCategory = await getProductCategory(existingProduct);
        // console.log('Final existing category:', existingCategory);
      } catch (error) {
        console.warn('Existing category fetch failed:', error);
      }

      if (existingCategory && newCategory && existingCategory.toLowerCase() !== newCategory.toLowerCase()) {
        // console.log('Category mismatch:', { existing: existingCategory, new: newCategory });
        showModal('Please add products from the same category only.', true);
        return;
      }
    } else if (newCategory) {
      // Set referenceCategory for first product if category exists
      // console.log('First product added with category:', newCategory);
      referenceCategory = newCategory;
      localStorage.setItem('compareReferenceCategory', JSON.stringify(referenceCategory));
    }

    // Ensure the product has a handle for future fetches
    if (!product.handle && product.url) {
      product.handle = product.url.split('/').pop().split('?')[0] || product.url.split('/').pop();
      // console.log('Extracted handle:', product.handle);
    }

    compareList.push(product);
    localStorage.setItem('compareList', JSON.stringify(compareList));
    // console.log('Added product to compareList:', product);
    showModal('Product added to comparison!');
    updateCompareCount();
    updateCompareButtonStates(); // Update button states after adding
    populateCompareGrid(); // Ensure grid is updated
  } catch (error) {
    console.error('Error in addToCompare:', error);
    showModal('Error adding product to comparison.', true);
  }
}

function setDynamicSpecHeights() {
  try {
    const grid = document.getElementById('compareGrid');
    if (!grid) return;

    const productCards = grid.querySelectorAll('.product-grid__item');
    if (productCards.length === 0) return;

    // Find the maximum number of specs across all cards
    const maxSpecs = Math.max(...Array.from(productCards).map(card => card.querySelectorAll('.product-spec').length));

    // For each row position
    for (let index = 0; index < maxSpecs; index++) {
      // Get all .product-spec elements at this index
      const rows = Array.from(productCards).map(card => card.querySelectorAll('.product-spec')[index]).filter(Boolean);
      if (rows.length === 0) continue;

      // Temporarily reset heights to measure natural height
      rows.forEach(row => {
        row.style.height = 'auto';
        row.style.overflow = 'visible';
      });

      // Calculate the maximum natural height for this row position
      const maxHeight = Math.max(...rows.map(row => row.getBoundingClientRect().height));

      // Apply the maximum height to all rows in this position
      rows.forEach(row => {
        row.style.height = `${maxHeight}px`;
        row.style.overflow = 'hidden';
        row.style.textOverflow = 'ellipsis';
        // Optional: Add title attribute for tooltip
        const label = row.querySelector('strong')?.textContent || '';
        const value = row.querySelector('.value')?.textContent || '';
        row.setAttribute('title', `${label}: ${value}`);
      });
    }
  } catch (error) {
    console.error('Error in setDynamicSpecHeights:', error);
  }
}

// Function to populate comparison grid - FIXED: Added ref="productCardLink" to the <a> element to satisfy the product-card component's required ref; Wrapped rendering in try/catch per product
function populateCompareGrid() {
  const grid = document.getElementById('compareGrid');
  if (!grid) {
    // console.log('Not on comparison page, skipping grid population.');
    return;
  }

  // console.log('Populating compare grid with', compareList.length, 'products');
  grid.innerHTML = '';

  if (compareList.length === 0) {
    grid.innerHTML = '<li class="product-grid__item"><h5>No products to compare yet.</h5></li>';
  } else {
    compareList.forEach((product, index) => {
      try {
        // FIXED: Removed !product.variant_id from validation (optional for rendering)
        if (!product.title || !product.price || !product.image || !product.url || !product.id) {
          console.error('Invalid product data in compareList at index', index, ':', product);
          return;
        }

        // Log specs for debugging
        // console.log('Product specs for ID', product.id, ':', product.specs);

        // Decode and parse specs
        const decodedSpecs = typeof product.specs === 'string' && product.specs.trim() !== ''
          ? decodeHtml(product.specs)
          : '';
        const specsArray = decodedSpecs ? parseSpecsTable(decodedSpecs) : [];
        const specsContent = specsArray.length > 0
          ? specsArray.map(spec => `<span class="product-spec"><strong>${spec.label}:</strong><span class="value">${spec.value} </span></span>`).join('')
          : '<span class="product-spec">No specifications available</span>';

        // Log rendered specs
        // console.log('Rendered specs for ID', product.id, ':', specsContent);

        const productCard = document.createElement('li');
        productCard.className = 'product-grid__item product-grid__item-column';
        productCard.setAttribute('data-product-id', product.id);

        // Render product card with specs as spans and product URL link - FIXED: Added ref="productCardLink" to <a>
        productCard.innerHTML = `
          <product-card class="product-card" data-product-id="${product.id}">
            <div class="
            product-card__content
            layout-panel-flex
            layout-panel-flex--column
            product-grid__card
            spacing-style
            border-style
            gap-style
          
          ">
            <a ref="productCardLink" class="product-card-link product-link" href="${product.url}" title="${product.title || 'Product'}"></a>
           <div class="product-info-group">
            <div
              style="--border-width: 1px; --border-style: none; --border-color: rgba(fromvar(--color-border) r g b / 1.0); --border-radius:0px;  -padding-block-start: 0px;--padding-block-end: 0px;--padding-inline-start: 0px;--padding-inline-end: 0px; --gallery-aspect-ratio:1;"
              class="card-gallery spacing-style border-style">

              <div class="product-media-container media-fit product-media-container--image">
                <button class="remove-compare" data-id="${product.id}">&times;</button>
                <div class="product-media product-media-padding">
                  <img src="${product.image}" alt="${product.title || 'Product'}" width="360" height="360" loading="lazy"  onerror="this.src='https://www.generaltechshop.ae/cdn/shop/files/gen-tech-placeholder2-trans.png';">
                </div>
              </div>
            </div>
            <div class="section__padding sku-block">
              <span class="product-sku f15 bold">
                ${product.partNumber ? `<span class="product-sku"><span class="sku-label">Part Number:</span>
                  ${product.partNumber}</span>` : ''}
                <span>
            </div>
            <div class="spacing-style product-title">
              ${product.title}
            </div>
   
          </div>
          <div class="product-spec-group">
            <h4 class="spec-heading">Specifications </h4>
            <div class="product-card__specs">
              <div class="product-spec-table">${specsContent}</div>
            </div>
          </div>
          </div>
          </product-card>
        `;
        grid.appendChild(productCard);
      } catch (renderError) {
        console.error('Error rendering product at index', index, ':', renderError, product);
        // Fallback: Render minimal card to avoid skipping entirely
        const fallbackCard = document.createElement('li');
        fallbackCard.className = 'product-grid__item product-grid__item-column';
        fallbackCard.innerHTML = `
          <div class="product-grid__card">
            <h5>Error loading product: ${product.title || 'Unknown'}</h5>
            <p><a href="${product.url || '#'}">View Product</a></p>
          </div>
        `;
        grid.appendChild(fallbackCard);
      }
    });
  }
  setDynamicSpecHeights();

  // Add event listener for card buttons using event delegation
  grid.removeEventListener('click', handleGridClick);
  grid.addEventListener('click', handleGridClick);
  console.log('Attached event listeners to compare grid');
}

// Function to handle clicks on remove and add-to-cart buttons
function handleGridClick(event) {
  try {
    console.log('handleGridClick triggered', { target: event.target.tagName, classList: event.target.classList.toString() });
    if (event.target.classList.contains('remove-compare')) {
      const id = event.target.dataset.id;
      console.log('Removing product with ID:', id);
      if (!id) {
        console.error('Missing data-id on remove-compare button:', event.target);
        showModal('Error: Cannot remove product.', true);
        return;
      }
      compareList = compareList.filter(item => String(item.id) !== String(id)); // FIXED: Strict inequality
      localStorage.setItem('compareList', JSON.stringify(compareList));
      // Update referenceCategory if list is empty
      if (compareList.length === 0) {
        referenceCategory = null;
        localStorage.removeItem('compareReferenceCategory');
        // console.log('Cleared referenceCategory');
      }
      populateCompareGrid();
      updateCompareCount();
      updateCompareButtonStates(); // Update button states after removing
      showModal('Product removed from comparison.');
    } else if (event.target.classList.contains('add-to-cart')) {
      const variantId = event.target.dataset.variantId;
      // console.log('Adding to cart, variant ID:', variantId);
      addToCart(variantId, event.target);
    }
  } catch (error) {
    console.error('Error in handleGridClick:', error);
    showModal('Error removing product from comparison.', true);
  }
}

async function addToCart(variantId, button) {
  try {
    button.disabled = true;
    button.textContent = 'Adding...';

    const response = await fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
      }),
    });

    if (!response.ok) {
      throw new Error(`Failed to add to cart: ${response.statusText}`);
    }

    const result = await response.json();
    // console.log('Added to cart:', result);
    showModal('Product added to cart!');
    await updateCartCount();
    openCartDrawer();
  } catch (error) {
    console.error('Error adding to cart:', error);
    showModal('Error adding product to cart. Please try again.', true);
  } finally {
    button.disabled = false;
    button.textContent = 'Add to Cart';
  }
}

// Function to update cart count
async function updateCartCount() {
  try {
    const response = await fetch('/cart.js');
    const cart = await response.json();
    const cartCountElements = document.querySelectorAll('.cart-count, .header__cart-count, .cart__item-count');
    cartCountElements.forEach(element => {
      element.textContent = cart.item_count;
    });
    // console.log('Updated cart count:', cart.item_count);

    if (typeof window.theme?.cart?.update === 'function') {
      window.theme.cart.update();
      // console.log('Triggered theme.cart.update');
    }
  } catch (error) {
    console.error('Error updating cart count:', error);
  }
}

// Function to open cart drawer
function openCartDrawer() {
  try {
    if (typeof window.theme?.cart?.open === 'function') {
      window.theme.cart.open();
      // console.log('Opened cart drawer via theme.cart.open');
      return;
    }

    const cartDrawer = document.querySelector('.cart-drawer, .ajax-cart, .drawer--cart');
    if (cartDrawer) {
      cartDrawer.classList.add('is-open');
      // console.log('Opened cart drawer via class toggle');
    } else {
      console.warn('Cart drawer element not found');
    }

    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: null } }));
  } catch (error) {
    console.error('Error opening cart drawer:', error);
  }
}

// Function to clear comparison list
function clearCompareList() {
  try {
    compareList = [];
    referenceCategory = null;
    localStorage.removeItem('compareList');
    localStorage.removeItem('compareReferenceCategory');
    localStorage.removeItem('categoryCache'); // Clear cache to avoid stale data
    // console.log('Comparison list cleared');
    populateCompareGrid();
    updateCompareCount();
    updateCompareButtonStates(); // Update button states after clearing
    showModal('Comparison list cleared.');
  } catch (error) {
    console.error('Error in clearCompareList:', error);
    showModal('Error clearing comparison list.', true);
  }
}

// NEW: Global flag to detect if on compare page
let isOnComparePage = false;

// Initialize comparison functionality (debounced to prevent excessive calls) - FIXED: Shorter debounce; Added check for compare page to skip unnecessary re-inits
const initializeCompare = debounce(() => {
  try {
    // FIXED: On compare page, skip button-related init to reduce logs/mutations
    isOnComparePage = !!document.getElementById('compareGrid');
    if (isOnComparePage) {
      // console.log('On compare page - skipping button init, only updating grid and clear button');
      updateCompareCount();
      const clearButton = document.getElementById('clearCompare');
      if (clearButton) {
        clearButton.removeEventListener('click', clearCompareList);
        clearButton.addEventListener('click', clearCompareList);
        // console.log('Attached clear button listener');
      }
      populateCompareGrid();
      return;
    }

    // console.log('Initializing compare functionality');
    // console.log('Current compareList state:', compareList);
    updateCompareCount();
    updateCompareButtonStates(); // Initialize button states

    // Use event delegation on document.body for reliability
    document.body.removeEventListener('click', handleAddToCompareDelegation);
    document.body.addEventListener('click', handleAddToCompareDelegation);
    // console.log('Attached add-to-compare event delegation to document.body');

    // FIXED: Skip direct attachment - delegation handles new buttons post-filter
    // console.log(`Skipping direct listeners - using delegation for ${document.querySelectorAll('.add-to-compare').length} buttons`);

    const clearButton = document.getElementById('clearCompare');
    if (clearButton) {
      clearButton.removeEventListener('click', clearCompareList);
      clearButton.addEventListener('click', clearCompareList);
      // console.log('Attached clear button listener');
    }

    populateCompareGrid();
    // console.log('Initialization complete');
  } catch (error) {
    console.error('Error in initializeCompare:', error);
  }
}, 100); // FIXED: Faster (100ms) for filter responsiveness

// REMOVED: handleAddToCompareDirect - Rely on delegation only to avoid conflicts

// Handle add to compare click via event delegation - FIXED: Use closest() to handle clicks on children (span/svg)
async function handleAddToCompareDelegation(event) {
  try {
    // console.log('handleAddToCompareDelegation triggered', {
    //   target: event.target.tagName,
    //   classList: event.target.classList.toString(),
    //   hasAddToCompare: event.target.classList.contains('add-to-compare')
    // });
    // FIXED: Check for closest ancestor with add-to-compare class (handles clicks on span or svg inside button)
    const button = event.target.closest('.add-to-compare');
    if (!button) {
      // console.log('No add-to-compare ancestor found, exiting');
      return;
    }
    const productData = button.dataset.product;
    // console.log('Raw data-product from button:', productData ? 'exists' : 'missing');

    if (!productData) {
      console.error('No data-product attribute found on button');
      showModal('Error: Product data is missing.', true);
      return;
    }

    // FIXED: Enhanced JSON cleaning for Liquid edge cases (newlines, nulls, extra escapes) - REMOVED unnecessary unescape for \" to prevent corruption
    let cleanedProductData = productData
      .replace(/,\s*}/g, '}') // Remove trailing commas before }
      .replace(/,\s*]/g, ']') // Remove trailing commas before ]
      .replace(/\\\//g, '/')  // Unescape forward slashes (kept for path escapes)
      .replace(/\\n/g, '')    // NEW: Remove escaped newlines
      .replace(/null/g, '""') // NEW: Convert null to empty string for defaults
      .replace(/("specs":\s*\{[^}]*\}),\s*("specs":\s*\{[^}]*\})/g, '$1') // FIXED: Remove duplicate "specs" if still present
      .trim();                // NEW: Trim whitespace

    // console.log('Cleaned data-product length:', cleanedProductData.length);
    let product;
    try {
      product = JSON.parse(cleanedProductData);
      // console.log('Parsed product:', product);
    } catch (parseError) {
      console.error('JSON parse error:', parseError, 'Raw data:', productData, 'Cleaned:', cleanedProductData);
      showModal('Error: Invalid product data format. Check console.', true);
      return;
    }

    // Validate required fields
    if (!product.id || !product.title || !product.url) {
      console.error('Missing required product fields:', { id: product.id, title: product.title, url: product.url });
      showModal('Error: Incomplete product data.', true);
      return;
    }

    // FIXED: Remove preventDefault/stopPropagation - let filters handle if needed
    await addToCompare(product);
  } catch (error) {
    console.error('Error in handleAddToCompareDelegation:', error, 'Raw data:', event.target.closest('.add-to-compare')?.dataset.product);
    showModal('Error adding product to comparison. Invalid product data.', true);
  }
}

// Set up MutationObserver to detect DOM changes (e.g., from filters) - FIXED: Enhanced filtering to ignore compare page mutations and self-triggered ones
function setupMutationObserver() {
  try {
    // FIXED: Broader target for collection/filter changes, but exclude compare page
    const compareGrid = document.getElementById('compareGrid');
    if (compareGrid) {
      // console.log('On compare page - setting up limited MutationObserver (ignore grid changes)');
      // On compare page, observe only body but ignore mutations in #compareGrid
      const targetNode = document.body;
      const observer = new MutationObserver(debounce((mutations) => {
        if (isOnComparePage) {
          // FIXED: Ignore any mutation where target or added/removed nodes are within #compareGrid
          const isCompareMutation = mutations.some(m => {
            if (m.target && m.target.closest('#compareGrid')) return true;
            if (m.addedNodes) {
              for (let node of m.addedNodes) {
                if (node.nodeType === 1 && node.closest('#compareGrid')) return true;
              }
            }
            if (m.removedNodes) {
              for (let node of m.removedNodes) {
                if (node.nodeType === 1 && node.closest('#compareGrid')) return true;
              }
            }
            return false;
          });
          if (isCompareMutation) {
            // console.log('Ignoring compare grid mutation');
            return;
          }
        }

        // FIXED: Ignore mutations from modal (e.g., class changes or removals on close)
        const isModalMutation = mutations.some(m => 
          m.target && (m.target.classList?.contains('compare-modal') || m.removedNodes?.length > 0 && Array.from(m.removedNodes).some(node => node.classList?.contains('compare-modal')))
        );
        if (isModalMutation) {
          // console.log('Ignoring modal-related mutation');
          return;
        }

        // console.log('DOM changed, re-initializing compare functionality', mutations.length, 'mutations');
        initializeCompare();
      }, 200)); // FIXED: Slightly longer debounce to reduce frequency

      observer.observe(targetNode, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['data-product', 'class'] // FIXED: Limit to relevant attrs
      });
      // console.log('Limited MutationObserver set up for compare page');
      return;
    }

    // Non-compare page setup
    const targetNode = document.querySelector('.product-grid, #MainContent, #shopify-section-collection, .collection') || document.body;
    // console.log('Setting up MutationObserver on:', targetNode.tagName, targetNode.id || targetNode.className);

    // Prevent self-triggered mutations
    let isUpdating = false;
    const observer = new MutationObserver(debounce((mutations) => {
      if (isUpdating) {
        console.log('Ignoring mutation caused by compare.js');
        return;
      }
      console.log('DOM changed, re-initializing compare functionality', mutations.length, 'mutations');
      isUpdating = true;
      // FIXED: Force cache clear on major changes (e.g., filter reload)
      if (mutations.some(m => m.type === 'childList' && m.addedNodes.length > 0)) {
        localStorage.removeItem('categoryCache');
      }
      initializeCompare();
      isUpdating = false;
    }, 200)); // FIXED: Slightly longer debounce

    observer.observe(targetNode, {
      childList: true,
      subtree: true,
      attributes: true, // FIXED: Watch for data-product attr changes post-filter
      attributeFilter: ['data-product'] // FIXED: Target only relevant attrs
    });
    // console.log('MutationObserver set up successfully');
  } catch (error) {
    console.error('Error setting up MutationObserver:', error);
  }
}

// Run initialization on page load
document.addEventListener('DOMContentLoaded', () => {
  // console.log('DOMContentLoaded: Initializing compare');
  initializeCompare();
  setupMutationObserver();
});

// Handle dynamic navigation and filter updates - FIXED: Added more events; On compare page, only re-init grid
document.addEventListener('shopify:section:load', () => {
  // console.log('shopify:section:load: Re-initializing compare');
  if (isOnComparePage) {
    populateCompareGrid();
  } else {
    initializeCompare();
  }
});
document.addEventListener('shopify:block:select', () => {
  // console.log('shopify:block:select: Re-initializing compare');
  if (isOnComparePage) {
    populateCompareGrid();
  } else {
    initializeCompare();
  }
});
document.addEventListener('shopify:filter:updated', () => {
  // console.log('shopify:filter:updated: Re-initializing compare');
  setTimeout(() => {
    if (isOnComparePage) {
      populateCompareGrid();
    } else {
      initializeCompare();
    }
  }, 50); // NEW: Small delay for DOM settle
});
window.addEventListener('popstate', () => {
  // console.log('popstate: Re-initializing compare');
  setTimeout(initializeCompare, 100); // Delay to allow page settle
});

// Handle custom filter events
document.addEventListener('filter:updated', () => {
  // console.log('custom filter:updated: Re-initializing compare');
  setTimeout(() => {
    if (isOnComparePage) {
      populateCompareGrid();
    } else {
      initializeCompare();
    }
  }, 50); // NEW: Delay for settle
});

// NEW: Additional theme events (adjust if your theme uses different ones)
document.addEventListener('collection:updated', () => { // Common in some themes
  // console.log('collection:updated: Re-initializing compare');
  setTimeout(() => {
    if (isOnComparePage) {
      populateCompareGrid();
    } else {
      initializeCompare();
    }
  }, 100);
}); 